
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

export interface MultipleSelectValue {
  name: string,
  id: number
}

@Component({
  name: 'MultipleSelectInputField'
})
export default class MultipleSelectInputField extends Vue {
  @Prop({ required: true })
  private id: string;

  @Prop({ required: true })
  private value: MultipleSelectValue[];

  @Prop({ required: true })
  private options: MultipleSelectValue[];

  @Prop({ required: true })
  private placeholder: string;

  @Prop({ default: false })
  private disabled: boolean;

  private input: string = '';

  get placeholderText() {
    if (this.value.length > 0) {
      return this.placeholder;
    } else {
      return "Alle";
    }
  }

  get remainingOptions(): MultipleSelectValue[] {
    return this.options.filter(value => this.value.findIndex(v => v.id === value.id) === -1);
  }

  private handleInput(e: { target: HTMLInputElement }) {
    this.input = e.target.value;
    const index = this.remainingOptions.findIndex(v => v.name === this.input);
    if (index !== -1) {
      this.input = '';
      this.addOption(this.remainingOptions[index]);
    }
  }

  private addOption(option: MultipleSelectValue) {
    this.$emit('input', this.value.concat(option));
  }

  private removeOption(option: MultipleSelectValue) {
    const copy = [...this.value];
    copy.splice(this.value.findIndex(v => v.id === option.id), 1);
    this.$emit('input', copy);
  }
}
